// extracted by css-extract-rspack-plugin
export default {"footer":"DropdownFooter_footer__jHvnL"};